export default "__VITE_ASSET__D2Ai5Jl0__"